"use client";

// src/components/textarea/textarea.tsx
import { useId, useImperativeHandle, useRef, useState } from "react";
import { textareaStyles } from "./textarea.styles.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var Textarea = ({
  label,
  name,
  description,
  value,
  defaultValue,
  placeholder,
  disabled = false,
  readOnly = false,
  rows,
  cols,
  minLength,
  maxLength,
  resize,
  error,
  className,
  onFocus,
  onBlur,
  ref,
  ...rest
}) => {
  const textareaRef = useRef(null);
  const uid = useId();
  const errorId = `${uid}-error`;
  const helperId = `${uid}-helper`;
  const [isFocused, setIsFocused] = useState(false);
  const isWithin = !!placeholder || isFocused || value;
  const style = textareaStyles({
    isInvalid: !!error
  });
  function focusOnTextarea() {
    textareaRef.current?.focus();
  }
  function handleFocus(event) {
    setIsFocused(true);
    onFocus && onFocus(event);
  }
  function handleBlur(event) {
    setIsFocused(!!textareaRef.current?.value);
    onBlur && onBlur(event);
  }
  useImperativeHandle(ref, () => textareaRef.current);
  return /* @__PURE__ */ jsxs("div", { className: style.container({ className: className?.container }), children: [
    description && /* @__PURE__ */ jsx("span", { id: helperId, className: style.helperText(), children: description }),
    label && /* @__PURE__ */ jsx(
      "label",
      {
        className: style.label({ className: className?.label }),
        htmlFor: uid,
        children: label
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: style.inputWrapper({ className: className?.inputWrapper }),
        "data-within": isWithin ? true : void 0,
        onClick: focusOnTextarea,
        "data-testid": "textarea-inner",
        children: /* @__PURE__ */ jsx(
          "textarea",
          {
            ...rest,
            ref: textareaRef,
            id: uid,
            name,
            className: style.textarea({ className: className?.textarea }),
            rows,
            cols,
            minLength,
            maxLength,
            placeholder,
            value,
            defaultValue,
            onFocus: handleFocus,
            onBlur: handleBlur,
            "aria-errormessage": error && errorId,
            "aria-invalid": error ? true : void 0,
            "aria-describedby": description ? helperId : void 0,
            disabled,
            readOnly,
            style: { resize: resize || "none" }
          }
        )
      }
    ),
    !error && /* @__PURE__ */ jsxs(
      "div",
      {
        className: style.lengthContainer({
          className: className?.lengthContainer
        }),
        children: [
          minLength && /* @__PURE__ */ jsxs("span", { className: style.minMaxText(), children: [
            "Min characters: ",
            minLength
          ] }),
          maxLength && /* @__PURE__ */ jsx("span", { className: style.minMaxText(), children: minLength ? `${String(value).length}/${maxLength}` : `${maxLength - String(value).length} characters remaining` })
        ]
      }
    ),
    error && /* @__PURE__ */ jsx("span", { id: errorId, role: "alert", className: style.error(), children: error })
  ] });
};
export {
  Textarea
};
